import { type NotificationMapper } from 'common/header/notifications/Notifications.types';

export const auditReportMapper: NotificationMapper = (notification, options) => {
  if (notification.status !== 'FINISHED_SUCCESS') return undefined;
  return {
    ...notification,
    iconType: 'SUCCESS',
    title: options.intl.auditReportTitle,
    to: `/${options.tenantCode}/configs/monitoring/audits`
  };
};
